import TextEncoder from 'text-encoding'
import TextDecoder from 'text-encoding'

// text-encoding-polyfill.js
(function (window) {
  if (typeof window.TextEncoder !== 'function') {
    window.TextEncoder = TextEncoder
    window.TextDecoder = TextDecoder
  }
}(window))